import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-slide-toggle-small], [xpoSlideToggleSmall]',
  host: { class: 'xpo-SlideToggle--small' },
})
export class XpoSlideSmallToggleDirective {}
